export default [
  {
    path: '/order_settings',
    meta: { label: 'Order Settings' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'order_settings',
        meta: {
          label: 'Order Settings',
          permission: 'show_all_order_settings'
        },
        component: () => import('./../../views/orderSettings/index'),
      },
      {
        path: ':id',
        meta: { label: 'Order Setting Details', permission: 'show_single_order_setting' },
        name: 'OrderSetting',
        component: () => import('./../../views/orderSettings/show'),
      },
      {
        path: ':id/edit',
        meta: { label: 'Edit Order Setting', permission: 'edit_order_setting' },
        name: 'EditOrderSetting',
        component: () => import('./../../views/orderSettings/edit')
      },
    ]
  },
  {
    path: '/order_bonus_settings',
    meta: { label: 'Order Bonus Settings' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'order_bonus_settings',
        meta: {
          label: 'Order Settings',
          permission: 'show_all_order_bonus_settings'
        },
        component: () => import('./../../views/order_bonus_settings/index.vue'),
      },
      {
        path: "/order_bonus_settings/create",
        name: "CreateOrderBonusSetting",
        component: () => import("./../../views/order_bonus_settings/create.vue"),
        meta: {
          permission: "create_order_bonus_setting",
        },
      },
      {
        path: "/order_bonus_settings/:id/edit",
        name: "EditOrderBonusSetting",
        component: () => import("@/views/order_bonus_settings/edit.vue"),
        meta: {
          permission: "edit_order_bonus_setting",
        },
      },
      {
        path: "/order_bonus_settings/:id",
        name: "ShowOrderBonusSetting",
        component: () => import("@/views/order_bonus_settings/show.vue"),
        meta: {
          permission: "show_order_bonus_setting",
        },
      },
    ]
  },


  {
    path: "order_payment_methods",
    name: "order_payment_methods",
    component: () => import("@/views/paymentmethods/index.vue"),
    meta: {
      permission: "show_all_order_payment_methods",
    },
  },
  {
    path: "order_payment_method/create",
    name: "create_order_payment_method",
    component: () => import("@/views/paymentmethods/create.vue"),
    meta: {
      permission: "create_order_payment_methods",
    },
  },
  {
    path: "order_payment_method/:id/edit",
    name: "edit_order_payment_method",
    component: () => import("@/views/paymentmethods/edit.vue"),
    meta: {
      permission: "edit_order_payment_method",
    },
  },

];
